
import React from "react";
import samave from '../../assets/video/samave.mp4'

const Video = () => {
  return (
    <div
      className="hidden md:block "
      style={{  width: "100%" ,height:'100%'}}
    >
      <video
        autoPlay
        loop
        playsInline
        muted
        style={{ width: "100%", height: "100%" }}
      >
        <source
          src={samave}
          type="video/mp4"
        />
      </video>

    </div>
  );
};

export default Video;
